var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggedIn)?_c('v-btn',{staticClass:"ml-2",attrs:{"min-width":"0","text":"","to":"/Account","exact":""}},[_c('v-icon',[_vm._v("mdi-account")]),_vm._v(" Mon compte ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }